/*
  global.js — FORMERA

  Comportamento essencial de interface. Nesta etapa NÃO há motion:
  as trocas são imediatas. Os pontos candidatos a movimento futuro
  estão marcados no HTML com `data-motion` e documentados em
  docs/MOTION.md — nenhuma biblioteca de animação é carregada.

  Tudo aqui é progressivo: sem JS, o Master mostra a primeira história
  e a galeria da PDP mostra a primeira imagem.
*/

(function () {
  'use strict';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  /* -------------------------------------------------------------------
     MASTER — histórias da abertura
     Sem autoplay por padrão. Quando ligado, pausa no hover, no foco e
     é ignorado por completo se o sistema pedir menos movimento.
  ------------------------------------------------------------------- */
  function initMaster(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-master-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-master-goto]'));
    var status = root.querySelector('[data-master-status]');
    var prev = root.querySelector('[data-master-prev]');
    var next = root.querySelector('[data-master-next]');
    var current = 0;
    var timer = null;

    function show(index, moveFocus) {
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        if (i === current) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });

      dots.forEach(function (dot, i) {
        if (i === current) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (status) {
        status.textContent = 'História ' + (current + 1) + ' de ' + slides.length;
      }

      if (moveFocus && dots[current]) dots[current].focus();
    }

    function go(step) {
      show(current + step, false);
      restart();
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restart() {
      stop();
      var seconds = parseInt(root.getAttribute('data-autoplay'), 10);
      if (!seconds || reduceMotion.matches) return;
      timer = window.setInterval(function () {
        show(current + 1, false);
      }, seconds * 1000);
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-master-goto'), 10), false);
        restart();
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(current - 1, true);
        restart();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(current + 1, true);
        restart();
      }
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', restart);

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', restart);
    }

    show(0, false);
    restart();
  }

  /* -------------------------------------------------------------------
     GALERIA DA PDP DEMONSTRATIVA — troca de imagem principal
  ------------------------------------------------------------------- */
  function initGallery(root) {
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var views = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-view]'));
    if (thumbs.length < 2 || views.length < 2) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-pdp-thumb');

        views.forEach(function (view) {
          if (view.getAttribute('data-pdp-view') === index) {
            view.removeAttribute('hidden');
          } else {
            view.setAttribute('hidden', '');
          }
        });

        thumbs.forEach(function (other) {
          other.setAttribute('aria-pressed', other === thumb ? 'true' : 'false');
        });
      });
    });
  }


  /* -------------------------------------------------------------------
     PAINÉIS DO HEADER — catálogo, •••, busca, conta e drawer mobile

     Um controlador único para todas as revelações do header. Só um
     painel aberto por vez. Esc fecha, clique fora fecha, o foco volta
     para o gatilho e `aria-expanded` acompanha o estado.
  ------------------------------------------------------------------- */
  function initHeaderPanels(header) {
    var toggles = Array.prototype.slice.call(header.querySelectorAll('[data-panel-toggle]'));
    if (!toggles.length) return;

    var overlay = header.querySelector('[data-panel-overlay]');
    var openId = null;

    function panelFor(id) {
      return header.querySelector('#' + id);
    }

    function close(returnFocus) {
      if (!openId) return;
      var panel = panelFor(openId);
      var trigger = header.querySelector('[data-panel-toggle="' + openId + '"]');

      if (panel) panel.setAttribute('hidden', '');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) trigger.focus();
      }
      if (overlay) overlay.setAttribute('hidden', '');
      header.removeAttribute('data-panel-open');
      openId = null;
    }

    function open(id) {
      var panel = panelFor(id);
      if (!panel) return;
      close(false);

      panel.removeAttribute('hidden');
      var trigger = header.querySelector('[data-panel-toggle="' + id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.removeAttribute('hidden');
      header.setAttribute('data-panel-open', id);
      openId = id;

      var focusTarget = panel.querySelector('[data-panel-focus]');
      if (focusTarget) focusTarget.focus();
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var id = toggle.getAttribute('data-panel-toggle');
        if (openId === id) {
          close(true);
        } else {
          open(id);
        }
      });
    });

    if (overlay) overlay.addEventListener('click', function () { close(false); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close(true);
    });

    document.addEventListener('focusin', function (event) {
      if (openId && !header.contains(event.target)) close(false);
    });

    header.addEventListener('panel:close', function () { close(false); });
  }

  /* -------------------------------------------------------------------
     HEADER STICKY INTELIGENTE

     Topo: comportamento normal. Rolando para baixo: recolhe para liberar
     área útil. Ao iniciar rolagem para cima: reaparece imediatamente.

     Mobile tem comportamento próprio, não é a redução do desktop: a
     linha de navegação recolhe antes (limiar menor), mantendo a linha de
     logo e utilidades acessível por mais tempo.

     Nunca recolhe com um painel aberto. A transição fica a cargo do CSS,
     que já é desativada sob prefers-reduced-motion.
  ------------------------------------------------------------------- */
  function initStickyHeader(header) {
    var lastY = window.pageYOffset;
    var ticking = false;

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function update() {
      var y = window.pageYOffset;
      var hideAfter = isMobile() ? 200 : 260;
      var condenseAfter = isMobile() ? 90 : 999999;
      var goingDown = y > lastY;

      if (header.hasAttribute('data-panel-open')) {
        header.classList.remove('site-header--hidden');
      } else if (goingDown && y > hideAfter) {
        header.classList.add('site-header--hidden');
      } else if (!goingDown) {
        header.classList.remove('site-header--hidden');
      }

      if (y > condenseAfter) {
        header.classList.add('site-header--condensed');
      } else {
        header.classList.remove('site-header--condensed');
      }

      header.classList.toggle('site-header--scrolled', y > 8);

      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* -------------------------------------------------------------------
     VOLTAR AO TOPO — só aparece depois de profundidade relevante
  ------------------------------------------------------------------- */
  function initToTop(button) {
    var ticking = false;

    function update() {
      var deep = window.pageYOffset > window.innerHeight * 1.5;
      if (deep) {
        button.removeAttribute('hidden');
      } else {
        button.setAttribute('hidden', '');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    button.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    });

    update();
  }


  /* -------------------------------------------------------------------
     Seletor de variantes da PDP.

     Realce progressivo, não substituição: o <select> nativo é a base que
     funciona sem JavaScript nenhum, e a Shopify só entende ele. Os chips
     aprovados começam ocultos no HTML; esta função os revela e esconde o
     select. Quem não tem JS vê só o select — nunca um controle bonito
     que não faz nada.

     Os chips continuam alimentando o MESMO campo `id` através do select:
     escolher um chip resolve a variante e atualiza o select, que é o que
     será enviado.
  ------------------------------------------------------------------- */
  function initVariantPicker(form) {
    var picker = form.querySelector('[data-variant-picker]');
    var fallback = form.querySelector('[data-variant-fallback]');
    var select = form.querySelector('[data-variant-select]');
    var dataTag = form.querySelector('[data-variant-data]');
    if (!picker || !fallback || !select || !dataTag) return;

    var variants;
    try {
      variants = JSON.parse(dataTag.textContent);
    } catch (e) {
      return; /* dado ilegível: mantém o select nativo, que funciona */
    }
    if (!variants || !variants.length) return;

    picker.removeAttribute('hidden');
    fallback.setAttribute('hidden', '');

    var priceValue = document.querySelector('[data-pdp-price-value]');
    var priceCompare = document.querySelector('[data-pdp-price-compare]');
    var button = form.querySelector('[data-add-to-cart]');
    var buttonLabel = form.querySelector('[data-add-to-cart-label]');
    var soldOutText = button ? button.getAttribute('data-sold-out-label') : null;
    var addText = buttonLabel ? buttonLabel.textContent.trim() : '';

    function chosen() {
      var values = [];
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        values[Number(input.getAttribute('data-option-position')) - 1] = input.value;
      });
      return values;
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var same = v.options.length === values.length;
        for (var j = 0; same && j < values.length; j++) {
          if (v.options[j] !== values[j]) same = false;
        }
        if (same) return v;
      }
      return null;
    }

    function update() {
      var variant = match(chosen());

      if (!variant) {
        /* Combinação que não existe: nada a comprar, e o botão precisa
           dizer isso em vez de mentir. */
        if (button) button.disabled = true;
        if (buttonLabel && soldOutText) buttonLabel.textContent = soldOutText;
        return;
      }

      select.value = String(variant.id);

      if (button) button.disabled = !variant.available;
      if (buttonLabel) {
        buttonLabel.textContent = variant.available ? addText : (soldOutText || buttonLabel.textContent);
      }

      if (priceValue) priceValue.textContent = variant.price;
      if (priceCompare) {
        if (variant.on_sale && variant.compare_at_price) {
          priceCompare.textContent = variant.compare_at_price;
          priceCompare.removeAttribute('hidden');
        } else {
          priceCompare.setAttribute('hidden', '');
        }
      }
    }

    picker.addEventListener('change', update);
    update();
  }


  /* -------------------------------------------------------------------
     Ordenação da coleção.

     Sem JavaScript, o <select> vem acompanhado de um botão que aplica a
     escolha — é o que funciona em qualquer navegador. Com JavaScript, a
     mudança aplica sozinha e o botão é REMOVIDO, para não sobrar um
     controle redundante na barra. Mesmo realce progressivo do seletor de
     variantes da PDP.

     O formulário é `method="get"` da própria Shopify: a URL resultante é
     canônica, com estado, histórico e compartilhamento da plataforma.
  ------------------------------------------------------------------- */
  function initSort(select) {
    var form = select.closest('form');
    if (!form) return;

    var aplicar = form.querySelector('[data-sort-apply]');
    if (aplicar) aplicar.remove();

    select.addEventListener('change', function () {
      form.submit();
    });
  }


  /* -------------------------------------------------------------------
     CRIAR — envio da solicitação.

     Realce progressivo. Sem JavaScript o formulário é um POST comum: o
     navegador vai até o Basin e a confirmação aparece lá. Com
     JavaScript, o envio acontece sem sair da loja e a confirmação toma o
     lugar do formulário.

     Nada aqui inventa validação: os campos obrigatórios são do próprio
     HTML e a validação que conta é a do servidor. O que este código faz é
     dar feedback — e, por princípio do tema, NENHUMA falha pode terminar
     em recarregar a página sem explicação.
  ------------------------------------------------------------------- */
  function initCriar(painel) {
    var form = painel.querySelector('[data-criar-form]');
    if (!form) return;

    var sucesso = painel.querySelector('[data-criar-sucesso]');
    var sucessoTexto = painel.querySelector('[data-criar-sucesso-texto]');
    var erro = form.querySelector('[data-criar-erro]');
    var erroTexto = form.querySelector('[data-criar-erro-texto]');
    var botao = form.querySelector('[data-criar-enviar]');
    var label = form.querySelector('[data-criar-enviar-label]');
    var anexos = form.querySelector('[data-criar-anexos]');
    var lista = form.querySelector('[data-criar-lista]');

    var maxArquivos = Number(form.getAttribute('data-max-arquivos')) || 5;
    var maxBytes = (Number(form.getAttribute('data-max-mb')) || 10) * 1024 * 1024;
    var textoEnviar = label ? label.textContent.trim() : '';

    /* O texto escrito no Liquid é a mensagem de origem. Guardá-lo permite
       voltar a ele quando a falha seguinte não tiver recado próprio. */
    var erroPadrao = erroTexto ? erroTexto.textContent.trim() : '';

    function mostrarErro(msg) {
      if (!erro) return;
      if (erroTexto) erroTexto.textContent = msg || erroPadrao;
      erro.hidden = false;
      erro.scrollIntoView({ block: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function limparErro() {
      if (erro) erro.hidden = true;
    }

    /* Lista os arquivos escolhidos e barra o que o servidor recusaria de
       qualquer jeito — melhor avisar antes do upload do que depois. */
    if (anexos && lista) {
      anexos.addEventListener('change', function () {
        limparErro();
        lista.textContent = '';
        var arquivos = Array.prototype.slice.call(anexos.files || []);
        if (!arquivos.length) return;

        if (arquivos.length > maxArquivos) {
          mostrarErro(lista.getAttribute('data-msg-demais') || '');
          anexos.value = '';
          return;
        }

        var grandes = arquivos.filter(function (f) { return f.size > maxBytes; });
        if (grandes.length) {
          mostrarErro(lista.getAttribute('data-msg-grande') || '');
          anexos.value = '';
          return;
        }

        lista.textContent = arquivos.map(function (f) { return f.name; }).join(' · ');
      });
    }

    form.addEventListener('submit', function (evento) {
      if (!form.checkValidity()) return; /* o navegador cuida do resto */
      evento.preventDefault();
      limparErro();

      if (botao) botao.disabled = true;
      if (label) label.textContent = label.getAttribute('data-enviando') || label.textContent;

      fetch(form.getAttribute('action'), {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          /* Nunca deixar o parser falar com a pessoa: uma página de erro
             em HTML faria `r.json()` estourar e o texto técnico da
             exceção viraria a mensagem na tela. Corpo ilegível vira
             recusa, e a recusa já tem texto humano escrito. */
          return r.text().then(function (bruto) {
            var dados = {};
            try { dados = JSON.parse(bruto); } catch (e) { dados = {}; }
            return { ok: r.ok, dados: dados };
          });
        })
        .then(function (resposta) {
          /* O Basin responde com `success: true` quando aceita. O HTTP
             status sozinho não basta: erro de validação também volta com
             corpo JSON. */
          var dados = resposta.dados || {};
          var aceito = resposta.ok && (dados.success === true || dados.ok === true);
          if (!aceito) {
            var recusa = new Error(dados.error || dados.erro || '');
            recusa.doServico = true;
            throw recusa;
          }
          if (sucessoTexto) {
            /* Só promete um número quando o serviço devolve um. Sem
               identificador, a confirmação é igualmente clara e não
               inventa protocolo que ninguém vai conseguir consultar. */
            var id = dados.id || dados.submission_id || '';
            var comId = sucessoTexto.getAttribute('data-modelo') || '';
            var semId = sucessoTexto.getAttribute('data-modelo-sem-id') || '';
            sucessoTexto.textContent = id ? comId.replace('{id}', id) : semId;
          }
          form.hidden = true;
          if (sucesso) {
            sucesso.hidden = false;
            sucesso.setAttribute('tabindex', '-1');
            sucesso.focus();
          }
        })
        .catch(function (e) {
          /* Só chega à tela o que o serviço disse. "Failed to fetch" e
             companhia são diagnóstico de navegador, em inglês: viram a
             mensagem escrita para a pessoa. */
          mostrarErro(e && e.doServico ? e.message : '');
        })
        .then(function () {
          if (botao) botao.disabled = false;
          if (label) label.textContent = textoEnviar;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-master]').forEach(initMaster);
    document.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (form) initVariantPicker(form);
    });
    document.querySelectorAll('[data-header]').forEach(function (header) {
      initHeaderPanels(header);
      initStickyHeader(header);
    });
    document.querySelectorAll('[data-sort-select]').forEach(initSort);
    document.querySelectorAll('[data-criar]').forEach(initCriar);
    document.querySelectorAll('[data-to-top]').forEach(initToTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Reinicializa dentro do editor de temas da Shopify. */
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    target.querySelectorAll('[data-master]').forEach(initMaster);
    target.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
    target.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (form) initVariantPicker(form);
    });
    target.querySelectorAll('[data-header]').forEach(function (header) {
      initHeaderPanels(header);
      initStickyHeader(header);
    });
    target.querySelectorAll('[data-sort-select]').forEach(initSort);
    target.querySelectorAll('[data-criar]').forEach(initCriar);
    target.querySelectorAll('[data-to-top]').forEach(initToTop);
  });
})();
